import { useSelector } from "@legendapp/state/react";
import { AlertCircle, CheckCircle, Upload, Wand2 } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Card, CardContent } from "@/components/ui/card";

import { getThumbnailReviewerState } from "./state";

export function HowItWorks() {
  const { t } = useTranslation();
  const step = useSelector(getThumbnailReviewerState.step);

  const getStepStyle = (stepName: "upload" | "description" | "results" | "improvements") => {
    return step === stepName ? "bg-green-500 text-white" : "bg-primary/10 text-primary";
  };

  return (
    <Card className="my-4">
      {/* <CardHeader className="pb-4">
        <CardTitle className="text-lg">{t('thumbnailReviewer.howItWorks.title')}</CardTitle>
        <CardDescription>{t('thumbnailReviewer.howItWorks.description')}</CardDescription>
      </CardHeader> */}
      <CardContent className="pb-2 pt-3">
        <div className="grid grid-cols-1 gap-3 md:grid-cols-4">
          <div className="flex flex-col items-center text-center">
            <div
              className={`mb-1.5 flex h-8 w-8 items-center justify-center rounded-full ${getStepStyle("upload")}`}
            >
              <Upload className="h-4 w-4" />
            </div>
            <h3 className={`mb-0.5 text-sm ${step === "upload" ? "font-bold" : "font-medium"}`}>
              {t("thumbnailReviewer.howItWorks.steps.upload.title")}
            </h3>
            <p className="text-xs text-gray-500">
              {t("thumbnailReviewer.howItWorks.steps.upload.description")}
            </p>
          </div>
          <div className="flex flex-col items-center text-center">
            <div
              className={`mb-1.5 flex h-8 w-8 items-center justify-center rounded-full ${getStepStyle("description")}`}
            >
              <CheckCircle className="h-4 w-4" />
            </div>
            <h3
              className={`mb-0.5 text-sm ${step === "description" ? "font-bold" : "font-medium"}`}
            >
              {t("thumbnailReviewer.howItWorks.steps.verify.title")}
            </h3>
            <p className="text-xs text-gray-500">
              {t("thumbnailReviewer.howItWorks.steps.verify.description")}
            </p>
          </div>
          <div className="flex flex-col items-center text-center">
            <div
              className={`mb-1.5 flex h-8 w-8 items-center justify-center rounded-full ${getStepStyle("results")}`}
            >
              <AlertCircle className="h-4 w-4" />
            </div>
            <h3 className={`mb-0.5 text-sm ${step === "results" ? "font-bold" : "font-medium"}`}>
              {t("thumbnailReviewer.howItWorks.steps.feedback.title")}
            </h3>
            <p className="text-xs text-gray-500">
              {t("thumbnailReviewer.howItWorks.steps.feedback.description")}
            </p>
          </div>
          <div className="flex flex-col items-center text-center">
            <div
              className={`mb-1.5 flex h-8 w-8 items-center justify-center rounded-full ${getStepStyle("improvements")}`}
            >
              <Wand2 className="h-4 w-4" />
            </div>
            <h3
              className={`mb-0.5 text-sm ${step === "improvements" ? "font-bold" : "font-medium"}`}
            >
              {t("thumbnailReviewer.howItWorks.steps.improve.title")}
            </h3>
            <p className="text-xs text-gray-500">
              {t("thumbnailReviewer.howItWorks.steps.improve.description")}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
